import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { Bell, X } from 'lucide-react';

const NotificationBanner = ({ type, onDismiss }) => {
  const { user } = useContext(AuthContext);
  
  // Don't show if user is not logged in
  if (!user) return null;
  
  // Check if user already has this notification enabled
  const notificationField = {
    'strategies': 'notify_new_strategies',
    'services': 'notify_new_services',
    'predictions': 'notify_ai_predictions',
    'blogs': 'notify_new_blogs'
  }[type];
  
  const isEnabled = user[notificationField];
  
  // Don't show if already enabled
  if (isEnabled) return null;
  
  const messages = {
    'strategies': 'Get notified when new betting strategies are added',
    'services': 'Get notified when new tipster services are available',
    'predictions': 'Get notified when new AI predictions are generated',
    'blogs': 'Get notified when new blog articles are published'
  };

  return (
    <div className="mb-6 bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/30 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-blue-500/20">
            <Bell className="w-5 h-5 text-blue-400" />
          </div>
          <div>
            <p className="text-white text-sm font-medium">Enable Email Notifications</p>
            <p className="text-gray-400 text-xs">{messages[type]}</p>
          </div>
        </div>
        <Link 
          to="/profile" 
          className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm rounded-lg transition-colors"
        >
          Enable in Profile
        </Link>
      </div>
    </div>
  );
};

export default NotificationBanner;
